var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaidInvoices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3954",
    "data-name": "Rectangle 3954",
    width: 49,
    height: 49,
    transform: "translate(0 0.188)",
    fill: "#2a4c7d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9782",
    "data-name": "Group 9782",
    transform: "translate(0 -0.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9743",
    "data-name": "Group 9743",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12135",
    "data-name": "Path 12135",
    d: "M24.594,0A24.594,24.594,0,1,0,49.188,24.594,24.6,24.6,0,0,0,24.594,0M37.25,18.651,22.8,33.151a2.609,2.609,0,0,1-1.793.769,2.4,2.4,0,0,1-1.793-.769l-7.276-7.276a2.572,2.572,0,1,1,3.638-3.638l5.431,5.431L33.663,15.013a2.537,2.537,0,0,1,3.638,0,2.583,2.583,0,0,1-.051,3.638",
    fill: "#2a4c7d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidInvoices);
export default __webpack_public_path__ + "static/media/PaidInvoices.57c65b7daa0c3e82817b5b24e6eef3d1.svg";
export { ForwardRef as ReactComponent };